module.exports = __webpack_public_path__ + "img/image1.99d084a3.png";